module.exports = __webpack_public_path__ + "img/icon-favourite-outline.7d2d8d8c.png";